<template>
  <div class="refuelingpoint">
    <div class="createOrder_head">
      <span>{{ data.site_name }} No.{{ data.site_id }}<br>{{ data.device_name }}</span>
      <span class="iconfont icon-xiangyou-copy"></span>
    </div>
    <div class="createOrder_content">
      <div>
        <span>可用油量</span>
        <span>{{ available_num }} 升</span>
      </div>
      <div>
        <span>确认油品质</span>
        <span>0#</span>
      </div>
      <div>
        <span class="fl"><label><span>{{ couponSelected }}</span><select @change="getCouponSelected"
                                                                         v-model="couponSelected"
                                                                         class="select_left select"><option
            v-for="coupon in couponList" :value="coupon.id">{{ coupon.name }}</option></select></label></span>
        <span class="editor" v-show="couponSelected=='加油油量'">
                        <input v-model="total_number" type="number" placeholder="请输入升数">&nbsp;
                        <span>升</span>
                    </span>
        <span class="editor" v-show="couponSelected=='加油金额'">
                        <input v-model="total_money" type="number" placeholder="请输入金额">&nbsp;
                        <span>元</span>
                    </span>
      </div>
      <div>
        <span>车牌号</span>
        <span class="license_plate">
                        <label><span>{{ car_num }}</span><select @change="getcarliet" class="select_right select"
                                                                 v-model="car_num"><option v-for="coupon in car_arr"
                                                                                           :value="coupon">{{ coupon }}</option></select></label>
                    </span>
      </div>
    </div>
    <div class="selecPayType_content" v-show="selecPayType_show">
      <div class="way_">
        <span>请选择支付方式</span>
      </div>
      <div class="selected_">
        <mt-radio
            v-model="pay_type"
            :options="options"
        >
        </mt-radio>
      </div>
    </div>
    <div class="bt" @click="submit">确定</div>
    <!-- 车牌未绑定，弹出提示框 -->
    <div v-show="nocar_num_show" class="nocar_num">
      <span class="nocar_num_text">车牌未绑定，请联系车队做司机车牌绑定操作</span>
      <span class="nocar_num_bt" @click="nocarBt">确认</span>
    </div>
  </div>
</template>

<script>
import common from "../../common";

export default {
  name: 'yunfeng_order',
  data() {
    return {
      data: "",
      car_num: "",//车牌号
      car_arr: [],//存放司机车牌号的数组
      gun_num: "",
      token: "",
      total_number: "",//数量
      total_money: "",//金额
      available_num: "",//可用油量
      pay_type: "账户余额支付",
      options: [
        {
          label: '账户余额支付',
          value: '账户余额支付',
        },
        {
          label: '微信支付',
          value: '微信支付'
        },
        {
          label: '支付宝支付',
          value: '支付宝支付'
        }
      ],
      couponList: [
        {
          id: '加油油量',
          name: "加油油量"
        },
        {
          id: "加油金额",
          name: "加油金额"
        }
      ],
      couponSelected: "加油油量",
      Submit_true: false,//提交了就为true,避免重复提交
      selecPayType_show: false,//选择支付方式默认不显示
      nocar_num_show: false
    }
  },
  methods: {
    nocarBt() {
      this.$router.push({name: 'login'});
    },
    submit() {
      if (parseFloat(this.total_number) > 0) {
        this.$set(this.data, 'total_number', this.total_number);
        let data_obj = JSON.stringify(this.data);
        this.$router.push({path: '/selfhelp/therefuel/' + data_obj});
      } else {
        common.toast("请输入加油量");
      }
    },
    //当选择加油金额时,显示选择支付方式;
    getCouponSelected() {
      if (this.couponSelected == "加油金额") {
        this.selecPayType_show = true;
      } else {
        this.selecPayType_show = false;
      }
    },
    //但车牌号改变时,可加油量也变;
    getcarliet() {
      this.getNumStation();
    },
    //获取可加油量以及油站信息
    getNumStation() {
      let querystring = require('querystring');
      this.$api.post('/wx/getDevice',
          querystring.stringify({
            token: this.token,
            car_number: this.car_num,
            gun_id: this.gun_num
          })
      ).then(data => {
        if (data.data.status == 1) {
          this.data = data.data.data;
          this.total_number = data.data.data.oil_surplus;
          this.available_num = data.data.data.oil_surplus;
        } else {
          this.available_num = 0;
          this.total_number = 0;
          common.toast(data.data.msg);
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    //获取用户openid
    getOpenid() {
      let url = window.location.href;
      let querystring = require('querystring');
      this.$api.post('/wx/getUrl',
          querystring.stringify({
            url
          })
      ).then(({data}) => {
        window.location.href = data;
      })
    },
    //查询用户是否绑定手机号;
    ifQueryBinding(openid) {
      let querystring = require('querystring');
      this.$api.post('/wx/checkOpenid',
          querystring.stringify({
            openid
          })
      ).then(({data}) => {
        if (data.status == 1) {
          //绑定了手机号,获取用户信息
          common.setCookie("token", data.data.token, 365);
          common.setCookie("mobile", data.data.mobile, 365);
          this.login_bol = true;
          this.token = data.data.token;
          this.getDate();
        } else {
          //没有绑定了手机号,去登录页绑定
          this.$router.push({
            name: 'login',
            query: {
              openid: openid
            }
          })
        }
      })
    },
    getDate() {
      //获取司机车牌号(可能有多个)
      let querystring = require('querystring');
      this.$api.post("wx/index",
          querystring.stringify({
            token: this.token,
          })
      ).then(data => {
        if (data.data.status == 1) {
          let car_Obj = data.data.data.car_list;
          //获取司机车牌号
          if (data.data.data.car_number) {
            this.car_num = data.data.data.car_number;
          } else {
            this.nocar_num_show = true;
          }
          for (var index in car_Obj) {
            this.car_arr.push(car_Obj[index]);
          }
          this.getNumStation();
        } else {
          this.$router.replace({name: 'login'});
        }
      })
    }
  },
  mounted() {
    this.gun_num = this.$router.currentRoute.params.gun_num;
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    //判断地址栏上是否存在openid;
    let ifopenid = window.location.href.indexOf("openid") != -1;
    //判断是否已经登录
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
      this.getDate();
    } else if (ifcookietoken) {
      this.token = common.getCookie("token");
      this.getDate();
    } else if (ifopenid) {
      let openid = window.location.href.split("openid=")[1].split("#/")[0];
      this.ifQueryBinding(openid);
    } else {
      this.getOpenid();
    }
  },
  watch: {
    total_number: function (nownum, oldnum) {
      if (parseFloat(nownum) > parseFloat(this.available_num)) {
        this.total_number = this.available_num;
        common.toast("可用油量为" + this.available_num + "升");
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.refuelingpoint {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f6f5f5;
  color: #666666;
}

.createOrder_head {
  width: 100vw;
  height: 13.4vh;
  background: white;
  margin: 18px 0;
  padding: 0 30px;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  font-size: .6rem;
}

.createOrder_content {
  width: 100vw;
  height: 32.5vh;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
}

.createOrder_content > div {
  flex: 1;
  border-bottom: 1px solid #f1f1f1;
  padding: 0 30px;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  font-size: .6rem;
}

.editor {
  display: -webkit-flex;
}

.editor > input {
  border: none;
  width: 30vw;
  text-align: right;
  color: #323333;
  font-size: .6rem;
  margin: 0;
}

.editor > span {
  display: -webkit-flex;
  align-items: center;
}

.editor > input::-webkit-input-placeholder {
  font-size: .6rem;
}

.license_plate {
  width: 30vw;
  height: 7vh;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  background: #0097fe;
  border-radius: 5px;
  color: white;
}

.license_plate > input {
  background: #0097fe;
  width: 100%;
  margin: 0;
  border: none;
  text-align: center;
  font-size: .6rem;
  color: white;
}

.refuelingpoint .bt {
  width: 30vw;
  margin: 100px auto;
  height: 70px;
  padding: 0 30px;
  background: #0097fe;
  border-radius: 5px;
  line-height: 70px;
  font-size: .6rem;
  color: white;
}

.selecPayType_content {
  width: 80vw;
  height: 295px;
  margin-top: 20px;
  padding: 0 30px 0 30px;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
}

.selecPayType_content > .way_ {
  width: 80vw;
  height: 95px;
  display: -webkit-flex;
  font-size: 28px;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
}

.selected_ {
  width: 80vw;
  height: 200px;
}

.refuelingpoint .mint-cell-title {
  text-align: left;
  height: 60px;
  font-size: 28px;
  line-height: 60px;
}

.select {
  color: #666666;
  text-align: left;
  font-size: 30px;
  margin-left: -8px;
  position: absolute;
  opacity: 0;
}

.select_right {
  left: 520px;
}

.select_left {
  left: 30px;
}

.addClass {
  padding: 20px !important;
}

.addClass > span {
  padding-top: 0 !important;
}

.refuelingpoint > .nocar_num {
  width: 80vw;
  height: 40vh;
  border: 1px solid rgb(26, 184, 164);
  background: white;
  left: 100px;
  position: absolute;
  top: 500px;
  display: -webkit-flex;
  flex-direction: column;
  font-size: 40px;
  justify-content: center;
  padding: 0;
}

.refuelingpoint > .nocar_num > .nocar_num_text {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.refuelingpoint > .nocar_num > .nocar_num_bt {
  width: 100%;
  background: #0097fe;
  height: 100px;
  line-height: 100px;
  color: white;
}
</style>
          


// WEBPACK FOOTER //
// src/components/selfhelp/order.vue